module.exports = __webpack_public_path__ + "img/a2.38708582.png";